import React from 'react';

const pageName = (page) => {
  if (typeof page === 'string') {
    return page;
  } else {
    return page.name;
  }
};

export default function usePage(props) {
  const {
    pages,
    setPages,
  } = props || {};
  const pop = React.useCallback((key) => {
    setPages(([...pages]) => {
      pages.pop();
      if (key) {
        if (typeof pages[pages.length - 1] === 'string') {
          pages[pages.length - 1] = { name: pages[pages.length - 1], props: { key } };
        } else {
          pages[pages.length - 1] = { name: pages[pages.length - 1].name, props: { ...pages[pages.length - 1].props, key } };
        }
      }
      return pages;
    });
  }, [setPages]);
  const onPop = React.useCallback((count = 1) => () => { while (count--) pop() }, [pop]);
  const push = React.useCallback((p) => {
    setPages(pages => [...pages.filter(page => {
      return pageName(page) !== pageName(p);
    }), p]);
  }, [setPages]);
  const onPage = React.useCallback((page, callback) => () => {
    push(page);
    callback && callback();
  }, [push]);
  const resetPages = React.useCallback((pages) => {
    setPages(() => ([]));
    pages.forEach(page => {
      push(page);
    });
  }, [setPages, push]);
  const onReset = React.useCallback((pages, callback) => () => {
    resetPages(pages);
    callback && callback();
  }, [resetPages]);
  const [frontPage, frontPageName] = React.useMemo(() => {
    const frontPage = pages[pages.length - 1];
    if (typeof frontPage === 'string') {
      return [{ frontPage }, frontPage];
    } else {
      return [frontPage, frontPage?.name];
    }
  }, [pages]);
  const frontPageTags = React.useMemo(() => {
    const {
      tags = [],
    } = frontPage || {};
    return [...tags, frontPageName];
  }, [frontPage, frontPageName]);
  return { resetPages, onReset, onPage, pop, push, onPop, frontPage, frontPageName, frontPageTags };
}
